<template>
  <section
    id="network"
    class="network section"
    data-testid="elem_u_000244"
  >
    <h2
      class="network-title"
      data-testid="elem_u_000245"
    >
      Our premium
      <span
        class="text-yellow"
        data-testid="elem_u_000246"
      >
        network
      </span>
    </h2>
    <p
      class="network-subtitle"
      data-testid="elem_u_000247"
    >
      The most Worldwide recognizable VR Porn websites.
    </p>
    <div
      class="scroll-wrapper"
      data-testid="elem_u_000248"
    >
      <div
        class="scrollable-items"
        @mousedown="handleMousedown"
        ref="slider"
        :style="{ maxWidth: sliderSize }"
        data-testid="elem_u_000249"
      >
        <div
          class="network-card"
          v-for="item in imageItems"
          :key="item.id"
          data-testid="elem_u_000250"
        >
          <template v-if="item.srcDesktop">
            <a
              :href="item.url"
              target="_blank"
              class="image-link"
              :class="{ hover: item.isHover }"
              :draggable="false"
              data-testid="elem_u_000251"
            >
              <picture
                draggable="false"
                data-testid="elem_u_000252"
              >
                <source
                  v-if="item.srcMobile"
                  media="(max-width: 668px)"
                  :srcset="item.srcMobile"
                  draggable="false"
                  data-testid="elem_u_000253"
                />
                <v-img
                  draggable="false"
                  cover
                  class="image"
                  :src="item.srcDesktop"
                  :alt="item.title"
                  data-testid="elem_u_000254"
                />
              </picture>
            </a>
            <a
              :href="item.url"
              target="_blank"
              class="image-title"
              :draggable="false"
              data-testid="elem_u_000255"
            >
              {{ item.title }}
            </a>
            <a
              :href="item.url"
              target="_blank"
              class="image-subtitle"
              :draggable="false"
              data-testid="elem_u_000256"
            >
              {{ item.subtitle }}
            </a>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Network',
  props: {
    images: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isScrolling: false,
      scrollStartX: null,
      scrollLeft: null,
      sliderSize: '100%',
    };
  },
  computed: {
    imageItems() {
      return [
        // {
        //   id: 1,
        //   url: 'https://vrporn.com',
        //   title: 'VR Porn',
        //   subtitle: 'The #1 VR Porn Site',
        //   srcDesktop: require('@/assets/img/home/network/vrporn.png'),
        // },
        {
          id: 2,
          url: 'https://vrbangers.com',
          title: 'VR Bangers',
          subtitle: 'Unreal 8K VR Porn',
          srcDesktop: require('@/assets/img/home/network/vrbangers.png'),
        },
        {
          id: 3,
          url: 'https://dezyred.com',
          title: 'Dezyred',
          subtitle: 'Interactive VR Porn Games',
          srcDesktop: require('@/assets/img/home/network/dezyred.png'),
        },
        {
          id: 8,
          url: 'https://vrsmash.com',
          title: 'VR Smash',
          subtitle: 'The Hottest VR Porn Library',
          srcDesktop: require('@/assets/img/home/network/vrsmash.png'),
        },
        {
          id: 4,
          url: 'https://vrconk.com',
          title: 'VR Conk',
          subtitle: 'Cosplay VR Porn',
          srcDesktop: require('@/assets/img/home/network/vrconk.png'),
        },
        {
          id: 5,
          url: 'https://blowvr.com',
          title: 'BLOW VR',
          subtitle: 'The Best Blowjobs in VR',
          srcDesktop: require('@/assets/img/home/network/blowvr.jpg'),
        },
        {
          id: 6,
          url: 'https://vrbtrans.com',
          title: 'VRB Trans',
          subtitle: 'The Biggest Trans Porn VR Site',
          srcDesktop: require('@/assets/img/home/network/vrbtrans.png'),
        },
        {
          id: 7,
          url: 'https://vrbgay.com',
          title: 'VRB Gay',
          subtitle: 'The Best Gay VR Porn Videos',
          srcDesktop: require('@/assets/img/home/network/vrbgay.png'),
        },
        {
          id: 9,
          url: 'https://arporn.com',
          title: 'AR Porn',
          subtitle: 'Passthrough VR Porn Videos',
          srcDesktop: require('@/assets/img/home/network/arporn.png'),
        },
      ];
    },
  },
  methods: {
    getImageSrc(itemCode) {
      if (this.images.length === 0) {
        return '';
      }
      const src = this.images.find((image) => image.code === itemCode)?.image ?? '';
      return src ? encodeURI(src) : '';
    },
    handleMousedown(event) {
      this.scrollLeft = this.$refs.slider.scrollLeft;
      this.scrollStartX = event.pageX - this.$refs.slider.offsetLeft;
    },
    handleMousemove(event) {
      if (this.scrollStartX) {
        event.preventDefault();
        event.stopPropagation();
        const currentX = event.pageX - this.$refs.slider.offsetLeft;
        const scroll = currentX - this.scrollStartX;
        this.isScrolling = Math.abs(scroll) > 5;
        this.$refs.slider.scrollLeft = this.scrollLeft - scroll;
      }
    },
    handleMouseup() {
      this.scrollLeft = null;
      this.scrollStartX = null;
    },
    handleClick(event) {
      if (this.isScrolling) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.isScrolling = false;
    },
    getSliderSize() {
      if (this.$refs.slider) {
        const rect = this.$refs.slider.getBoundingClientRect();
        const distance = window.innerWidth - rect.left;
        this.sliderSize = `${distance}px`;
      }
    },
  },
  created() {
    document.addEventListener('mouseup', this.handleMouseup, false);
    document.addEventListener('mousemove', this.handleMousemove, false);
    document.addEventListener('click', this.handleClick, false);
    window.addEventListener('resize', this.getSliderSize, { lazy: true });
  },
  mounted() {
    this.getSliderSize();
  },
  beforeDestroy() {
    document.removeEventListener('mouseup', this.handleMouseup);
    document.removeEventListener('mousemove', this.handleMousemove);
    document.removeEventListener('click', this.handleClick);
    window.removeEventListener('resize', this.getSliderSize);
  },
};
</script>

<style lang="scss" scoped>
.network {
  width: 100%;
  margin: 0 auto;
  padding-top: 100px;
  padding-bottom: 100px;

  @include lg-down {
    padding-top: 50px;
    padding-bottom: 50px;
  }
  @include sm-down {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .network-subtitle {
    color: #8d8d8d;
  }

  .network-title {
    color: var(--color-grey-900);
    font-size: 42px;
    font-weight: 700;
    line-height: 49px;
    margin: 0;
    padding: 0;

    @include lg-down {
      font-size: 30px;
      line-height: 35px;
    }
    @include sm-down {
      font-size: 24px;
      line-height: 28px;
    }
  }

  .network-subtitle {
    font-size: 20px;
    font-weight: 400;
    line-height: 23px;
    padding: 0;
    margin: 20px 0 0;

    @include lg-down {
      font-size: 16px;
      line-height: 19px;
    }
  }

  .text-yellow {
    color: var(--color-primary);
  }

  .scroll-wrapper {
    width: 100%;
    margin-top: 50px;

    @media (max-width: 1920px) {
      width: 100vw;
      left: -130px;
    }
    @include lg-down {
      left: -20px;
    }
    @include sm-down {
      left: -15px;
      margin-top: 30px;
    }
  }

  .scrollable-items {
    position: relative;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    width: fit-content;
    cursor: pointer;
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    padding: 0 20px;
    left: -20px;

    @include sm-down {
      padding: 0 15px;
      left: -15px;
      gap: 10px;
    }
  }

  .network-card {
    height: auto;
    width: fit-content;
    user-select: none;

    &:nth-child(2) {
      .image-subtitle {
        @include sm-down {
          font-size: 16px;
          line-height: 22px;
        }
      }
    }
  }

  .image-link {
    display: flex;
    height: 492px;
    width: 400px;
    min-width: 400px;
    display: block !important;

    @include lg-down {
      height: 318px;
      width: 259px;
      min-width: 259px;
    }
    @include sm-down {
      height: 183px;
      width: 150px;
      min-width: 150px;
    }
  }

  .image {
    width: 100%;
    height: 100%;
    border-radius: 20px;

    @include sm-down {
      border-radius: 10px;
    }
  }

  .image-title {
    overflow: hidden;
    text-decoration: none;
    color: var(--color-grey-900);
    text-overflow: ellipsis;
    font-size: 20px;
    font-weight: 700;
    line-height: 23px;
    display: flex;
    padding-top: 20px;

    @include sm-down {
      font-size: 16px;
      line-height: 19px;
    }
  }

  .image-subtitle {
    text-decoration: none;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    display: flex;
    padding-top: 5px;

    @include sm-down {
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
